














































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { date } from '@/util/adapter';
import storage from 'baimahu/storage';
const getUrl = require('bmh/url-with-param');
const uuidv4 = require('uuid/v4');
const dateFormat = require('bmh/date-format');
const numeral = require('numeral');
const { VUE_APP_FCAPI: FCAPI } = process.env;

function getPagingData(remote?: RemotePagination<any>) {
  remote = (remote || {}) as RemotePagination<any>;
  const current = remote.current_page;
  return {
    current: +current || 1,
    data: remote.data || [],
    last: remote.last_page || 1,
    size: remote.per_page || 1,
    total: remote.total || 0,
  };
}

interface Form {
  number: number | undefined;
  order: string | undefined;
  brand_name: string | undefined;
  pay_time: Moment[];
  order_status: number | undefined;
  bring_type: number | undefined;
}

const API = {
  desc: `${FCAPI}/shang/promotion/activity`,
  award_order: `${FCAPI}/shang/dian/venue/merchant/activity/order/stats`,
  award_detail: `${FCAPI}/shang/dian/venue/merchant/activity/order`,
};
const ORDER_STATUS_LIST: any[] = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 5,
    label: '待发货',
  },
  {
    value: 10,
    label: '已发货',
  },
  {
    value: 15,
    label: '已完成',
  },
];
const BRING_TYPE_LIST: any[] = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '带单',
  },
  {
    value: 2,
    label: '被带单',
  },
];

@Component
export default class ActivityConfig extends Vue {
  activity: any = {};
  activity_id: any = '';
  merchant_name: string = '';
  award_data: any = {
    data: [],
  };
  total_list: any = {
    data: [],
  };
  show_award_list_current_page: number = 1;
  form: Form = {
    number: undefined,
    order: '',
    brand_name: '',
    pay_time: [],
    order_status: 0,
    bring_type: 0,
  };
  award_detail: any = {};
  is_loading: boolean = false;
  now_timestamp: number = 0;
  page: number = 1;
  award_type: number = 0;
  order_status_list: any = ORDER_STATUS_LIST;
  order_status_list_obj: any = {};
  bring_type_list: any = BRING_TYPE_LIST;
  send_data: any = {};

  get awardData(): Pagination<any> {
    const size = 5;
    const total = this.award_data.data.length;
    const current = this.show_award_list_current_page || 1;
    let last = total / size;
    if (last > ~~last || last === 0) {
      // 不是整数或无数据
      last = ~~last + 1;
    }
    const data = this.award_data.data.slice(
      (current - 1) * size,
      current * size,
    );
    return {
      current,
      data,
      last,
      size,
      total,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  handChangeAwardPaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    if (next_page !== this.show_award_list_current_page) {
      this.show_award_list_current_page = next_page;
    }
  }
  awardPaginationOption(data: Pagination<any>) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.size}条`,
      pageSize: data.size,
      current: data.current,
    };
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getAwardDetail(next_page);
  }

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  clearForm() {
    const form = this.form;
    form.number = undefined;
    form.order = '';
    form.brand_name = '';
    form.pay_time = [];
    form.order_status = 0;
    form.bring_type = 0;
  }

  async query() {
    this.is_loading = true;
    const _data =
      ((await this.$axios.get(`${API.desc}/${this.activity_id}`)) || {}).data ||
      {};
    this.is_loading = false;
    if (_data.error) {
      console.debug(_data.message);
      return;
    }
    this.activity = _data.data;
    this.now_timestamp = ~~(+new Date() / 1000);
    if (this.now_timestamp < this.activity.start_time) {
      this.activity.activity_status = '未开始';
    } else {
      if (this.now_timestamp < this.activity.end_time) {
        this.activity.activity_status = '进行中';
      } else {
        this.activity.activity_status = '已结束';
      }
    }
  }

  async getAwardData() {
    const res = await this.$axios.get(
      `${API.award_order}?activity_id=${this.activity_id}`,
    );
    if (res.data.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    const data = res.data.data || {};
    this.award_data.data = data.list;
    this.award_data.data.forEach((item: any) => {
      item._key = uuidv4();
    });
    this.total_list.data = [data.total];
    this.total_list.data.forEach((item: any) => {
      item._key = uuidv4();
    });
  }

  getSendData() {
    const send_data: any = {
      activity_id: this.activity_id,
      venue_code: this.form.number,
      trade_no: this.form.order,
      merchant_name: this.form.brand_name,
      pay_time_start: this.form.pay_time[0]
        ? this.form.pay_time[0].format('X')
        : '',
      pay_time_end: this.form.pay_time[1]
        ? this.form.pay_time[1].format('X') + 86400
        : '',
      order_status: this.form.order_status,
      refer_status: this.form.bring_type,
    };
    this.send_data = send_data;
  }

  async getAwardDetail(page: number = 1) {
    this.page = page;
    await this.getSendData();
    this.send_data.current = this.page;
    this.send_data.limit = 20;
    const res = await this.$axios.get(API.award_detail, {
      params: this.send_data,
    });
    if (res.data.status !== 200) {
      this.award_detail = [];
      console.debug(res.data.message);
      return;
    }
    this.award_detail = res.data.data;
  }

  exportData() {
    this.getSendData();
    this.send_data.is_export = 1;
    const params = this.send_data;
    let url = '';
    url = `${API.award_detail}?`;
    for (const key in params) {
      if (key && params[key]) {
        url += `&${key}=${params[key]}`;
      }
    }
    window.location.href = url;
  }

  submit() {
    this.getAwardDetail(1);
  }

  async created() {
    if (this.$route.query.activity_id) {
      this.activity_id = this.$route.query.activity_id;
    }
    this.order_status_list.forEach((item: any) => {
      this.order_status_list_obj[item.value] = item.label;
    });
    const profile = storage.getItem('profile') || {};
    this.merchant_name = profile.name;
    await this.query();
    await this.getAwardData();
    await this.getAwardDetail(1);
  }
}
